import React from "react";
import styled from "styled-components";

import smallWorkflowImage from "../../assets/copysmith-workflow-small.png";
import {
  ContentBlock,
  Image,
  Section,
} from "../../components/shared/layout/Layout";
import Capital from "../../components/shared/text/Capital";
import Headline from "../../components/shared/text/Headline";
import {
  LargeBodyText,
  MediumHeaderText,
} from "../../components/shared/text/Text";

const Box = styled.div`
  display: flex;
  flex-direction: column;
  padding: 38px;
  max-width: 561px;
`;

const StepBox = ({ step, title, content }) => {
  return (
    <Box className="col-11 col-md-12">
      <div className="d-flex align-items-center">
        <Capital>{step}</Capital>
        <MediumHeaderText className="text-left mt-2 ml-2 mt-md-4 ml-md-4">
          {title}
        </MediumHeaderText>
      </div>
      <LargeBodyText className="mt-2 text-left">{content}</LargeBodyText>
    </Box>
  );
};

const Steps = (props) => {
  return (
    <ContentBlock
      className="d-flex flex-column align-items-center"
      id="steps"
      {...props}
    >
      <Headline className="col-12 col-md-5 text-center">
        Compelling content with 10 seconds of work
      </Headline>
      {/* <LargeBodyText className='col-10 col-md-8 mt-4 text-center'>
      </LargeBodyText> */}

      <Section className="flex-column-reverse flex-md-row">
        <StepBox
          step={1}
          title="You answer 6 short questions."
          content="Submit your company name, the tone, and keywords or products to focus on."
        />
        <Image
          src="https://i.imgur.com/k47h3PO.png"
          alt="Service workflow"
          title="Workflow"
        />
      </Section>
      <Section>
        <Image
          src={smallWorkflowImage}
          alt="Showcase service"
          title="Workflow"
        />
        <StepBox
          step={2}
          title={"You're done."}
          content={
            "If it's a blog post, our expert copywriter will polish the AI-generated article and send it back to you. For all the other services, you'll be able to regenerate and perfect the AI output yourself."
          }
        />
      </Section>
    </ContentBlock>
  );
};

export default Steps;
